
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions-and-events/online/[slug]/[object]",
      function () {
        return require("private-next-pages/exhibitions-and-events/online/[slug]/[object].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitions-and-events/online/[slug]/[object]"])
      });
    }
  